import styled from 'styled-components';
export const ChannelFooter = styled.section.withConfig({
  componentId: "sc-8acbbv-0"
})(["", ""], {
  "borderTopWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.5rem"
});
export const TypingIndicator = styled.div.withConfig({
  componentId: "sc-8acbbv-1"
})(["", " ", ""], {
  "display": "flex",
  "height": "fit-content",
  "width": "100%",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingBottom": "0.25rem"
}, {
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
});
export const ReplyingIndicator = styled.div.withConfig({
  componentId: "sc-8acbbv-2"
})(["", " align-items:flex-start;justify-content:space-between;.header{", " .counterpart{", "}}.reply-message-content{", "}"], {
  "height": "fit-content",
  "paddingBottom": "0.5rem"
}, {
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "space-between"
}, {
  "width": "fit-content",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(105 117 134 / var(--tw-text-opacity, 1))"
});
export const MessageInputContainer = styled.section.withConfig({
  componentId: "sc-8acbbv-3"
})(["&{", "}"], {
  "position": "relative",
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "flex-end",
  "gap": "0.5rem"
});
export const MessageInput = styled.div.withConfig({
  componentId: "sc-8acbbv-4"
})(["&{", " ", " border-color:", ";> div:not(.send-button){", " textarea,textarea:focus,textarea:active{", " outline:0;min-height:", ";height:", ";max-height:", ";}}.send-button{", "}}"], {
  "position": "relative",
  "display": "flex",
  "height": "fit-content",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "flex-end",
  "gap": "0.5rem",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem"
}, {
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "borderStyle": "solid"
}, props => props.isFocused ? 'var(--gray-10)' : 'var(--gray-60)', {
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "flexGrow": "1",
  "flexDirection": "column"
}, {
  "resize": "none",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, props => props.minHeight, props => props.minHeight, props => props.maxHeight, {
  "marginTop": "auto",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center"
});
export const ImagePreviewContainer = styled.div.withConfig({
  componentId: "sc-8acbbv-5"
})(["display:flex;flex-wrap:wrap;", " > .image-preview-item{position:relative;", ";img{width:100%;height:100%;object-fit:cover;border-radius:8px;}.remove-button{position:absolute;", ";border-radius:50%;border:none;display:flex;align-items:center;justify-content:center;padding:0;}}"], {
  "gap": "0.38rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
}, {
  "height": "3rem",
  "width": "3rem"
}, {
  "right": "-4px",
  "top": "-4px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))"
});